<!---- Copyright The Linux Foundation and each contributor to LFX.-->
<!---- SPDX-License-Identifier: MITs -->
<div class="not-supported-container">
  <img src="assets/img/svgs/ic_info_outline.svg" />
  <div class="not-supported-text">
    Not all features are available on mobile view.
  </div>
  <img src="assets/img/svgs/ic_close.svg" style="margin-inline-start: auto;" />
</div>
